import "./forms.scss";
import { Redirect, Route, Switch } from "react-router";
import { PathName } from "../../constants/PathName";
import { FormDetail } from "./formDetail/FormDetail";

export const Forms = () => {
	return (
		<Switch>
			<Route exact path={PathName.FORMS(":formId")} render={() => <FormDetail />} />
			<Route render={() => <Redirect to={PathName.DASHBOARD} />} />
		</Switch>
	);
};
